var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { isArray } from 'lodash';
import moment from 'moment-timezone';
import { default as React, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { getUserId, useUserInformation } from '../Authentication/ApplicationAuthentication';
import { Button, ButtonVariant } from '../Components/Button';
import { StyledDialog } from '../Components/Dialog/StyledDialog';
import { StyledDialogButton } from '../Components/Dialog/StyledDialogButton';
import { useError } from '../Components/ErrorBoundary';
import { CloseIcon } from '../Components/Icons';
import { displayError, getUserManager } from '../Config/ApplicationConfig';
import { convertTimeUnitsToUnitOfTime, useMedicationSettings } from '../Config/MedicationConfig';
import { PoisonScheduleStatus } from '../Contracts/MedicationModels';
import { white50 } from '../Styles/Colours';
import styles from './ControlledMedicationDialog.module.css';
export var ControlledDialogActions;
(function (ControlledDialogActions) {
    ControlledDialogActions[ControlledDialogActions["Represcribe"] = 0] = "Represcribe";
    ControlledDialogActions[ControlledDialogActions["AddMedication"] = 1] = "AddMedication";
    ControlledDialogActions[ControlledDialogActions["Edit"] = 2] = "Edit";
})(ControlledDialogActions || (ControlledDialogActions = {}));
var Last_Auth_DateTime_Key = 'communicare-timer-6ADDE5A0-6345-4DE4-A2D8-F7D9DF3F30CB';
var isControlledMedication = function (poisonScheduleStatus) {
    return poisonScheduleStatus === PoisonScheduleStatus.Alert;
};
export var useControlledMedicationDialog = function (config) {
    var throwError = useError();
    var medSettings = useMedicationSettings();
    var _a = __read(useState(null), 2), dialogConfig = _a[0], setDialogConfig = _a[1];
    var _b = __read(useState(false), 2), processingLogin = _b[0], setProcessingLogin = _b[1];
    var history = useHistory();
    var userInformation = useUserInformation();
    var showControlledMedicationDialog = function (config) {
        setDialogConfig(config);
    };
    var onCancelControlDialog = function () {
        setDialogConfig(null);
        if (dialogConfig) {
            dialogConfig.handleCancel();
        }
    };
    var handleLoginFlow = function () { return __awaiter(void 0, void 0, void 0, function () {
        var action, _a, valueToSave, payloadKey, manager, errorMessage;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setProcessingLogin(true);
                    if (!dialogConfig) return [3 /*break*/, 2];
                    action = dialogConfig.action;
                    action.timeStamp = new Date().toISOString();
                    _a = action;
                    return [4 /*yield*/, getUserId()];
                case 1:
                    _a.userId = _b.sent();
                    valueToSave = JSON.stringify(action);
                    payloadKey = uuidv4();
                    sessionStorage.setItem(payloadKey, valueToSave);
                    manager = getUserManager();
                    if (manager) {
                        config.saveAppUrlForReload(config.rootUrl + "?payloadKey=" + payloadKey);
                        manager.signinRedirect({
                            prompt: 'login' // - This setting will force a user to log back in (vs quick login if they have a valid token)
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    errorMessage = 'Login flow called without a dialog action stored';
                    console.error(errorMessage);
                    displayError(errorMessage);
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var requiresAuthentication = function (poisonScheduleStatus) {
        // Are any of the drugs S8? If yes, we need to check the user.
        var isControlledSubstance = isArray(poisonScheduleStatus)
            ? poisonScheduleStatus.findIndex(isControlledMedication) >= 0
            : isControlledMedication(poisonScheduleStatus);
        // If they want to do an action with a controlled substance
        if (isControlledSubstance) {
            var lastAuthString = sessionStorage.getItem(Last_Auth_DateTime_Key);
            if (!lastAuthString) {
                sessionStorage.removeItem(Last_Auth_DateTime_Key);
                return true;
            }
            var authTimeStamp = void 0;
            try {
                authTimeStamp = JSON.parse(lastAuthString);
            }
            catch (err) {
                sessionStorage.removeItem(Last_Auth_DateTime_Key);
                console.error('Unable to parse stored auth information');
                // TODO: Should this throwError?
                return true;
            }
            if (authTimeStamp.userId !== userInformation.user.userId) {
                sessionStorage.removeItem(Last_Auth_DateTime_Key);
                return true;
            }
            var lastAuthDateTime = moment(authTimeStamp.timeStamp);
            // If the last auth is somehow a invalid datetime, they must auth
            if (!lastAuthDateTime.isValid())
                return true;
            var reloginChallengeGracePeriod = medSettings.settings.reloginChallengeGracePeriod;
            if (!reloginChallengeGracePeriod)
                return true;
            var lastAuthTimeInMinutes = moment().diff(lastAuthDateTime, convertTimeUnitsToUnitOfTime(reloginChallengeGracePeriod.timeUnits));
            console.log("User last authenticated: " + lastAuthTimeInMinutes + " minutes ago");
            // TODO: Replace 10 with medication settings value.
            // If the last auth time is too old,they must auth.
            if (lastAuthTimeInMinutes > reloginChallengeGracePeriod.number) {
                return true;
            }
        }
        // In all other situations they do not need to auth again.
        return false;
    };
    var handleReload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var urlParams, payloadKey, controlledMedicationActionString, controlledMedicationConfig, currentUserId, payloadUserId, timeStamp, ageOfTimeStampInMinutes, successAuthInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    urlParams = new URLSearchParams(window.location.search);
                    payloadKey = urlParams.get('payloadKey');
                    if (!payloadKey)
                        return [2 /*return*/];
                    // Clear the query string off the url
                    history.replace(window.location.pathname);
                    controlledMedicationActionString = window.sessionStorage.getItem(payloadKey);
                    window.sessionStorage.removeItem(payloadKey);
                    if (!controlledMedicationActionString) {
                        sessionStorage.removeItem(Last_Auth_DateTime_Key);
                        return [2 /*return*/];
                    }
                    try {
                        controlledMedicationConfig = JSON.parse(controlledMedicationActionString);
                    }
                    catch (err) {
                        sessionStorage.removeItem(Last_Auth_DateTime_Key);
                        console.error('Unable to parse stored controlled medication action');
                        // TODO: Should this throwError?
                        return [2 /*return*/];
                    }
                    if (!controlledMedicationConfig || !controlledMedicationConfig.timeStamp) {
                        sessionStorage.removeItem(Last_Auth_DateTime_Key);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getUserId()];
                case 1:
                    currentUserId = _a.sent();
                    payloadUserId = controlledMedicationConfig.userId;
                    if (currentUserId !== payloadUserId) {
                        sessionStorage.removeItem(Last_Auth_DateTime_Key);
                        throwError(new Error('You did not login as the original user who created the medication'));
                        return [2 /*return*/];
                    }
                    timeStamp = moment(controlledMedicationConfig.timeStamp);
                    ageOfTimeStampInMinutes = moment().diff(timeStamp, 'minutes');
                    // Only process the result if it's younger than 10 minutes
                    if (!timeStamp.isValid() || ageOfTimeStampInMinutes > 10) {
                        return [2 /*return*/];
                    }
                    successAuthInfo = {
                        userId: currentUserId,
                        timeStamp: new Date().toISOString()
                    };
                    sessionStorage.setItem(Last_Auth_DateTime_Key, JSON.stringify(successAuthInfo));
                    switch (controlledMedicationConfig.type) {
                        case ControlledDialogActions.AddMedication:
                            console.log('Controlled add medication was called');
                            config.handleAddMedication(controlledMedicationConfig);
                            break;
                        case ControlledDialogActions.Represcribe:
                            console.log('Controlled represcribe was called');
                            config.handleReprescribe(controlledMedicationConfig);
                            break;
                        case ControlledDialogActions.Edit:
                            console.log('Controlled edit was called');
                            config.handleEditMedication(controlledMedicationConfig);
                            break;
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        handleReload();
    }, []);
    var controlledMedications = [];
    switch (dialogConfig === null || dialogConfig === void 0 ? void 0 : dialogConfig.action.type) {
        case ControlledDialogActions.AddMedication:
            if (dialogConfig.action.payload.medication)
                controlledMedications = [
                    {
                        id: dialogConfig.action.payload.medication.code,
                        name: dialogConfig.action.payload.medication.name
                    }
                ];
            break;
        case ControlledDialogActions.Represcribe:
            controlledMedications = dialogConfig.action.payload.medications
                .filter(function (it) { var _a; return isControlledMedication((_a = it.poisonSchedule) === null || _a === void 0 ? void 0 : _a.poisonScheduleStatus); })
                .map(function (it) {
                var _a, _b, _c, _d;
                return ({
                    id: it.medication.id,
                    name: (_d = (((_a = it.shortenedMedsDetails) === null || _a === void 0 ? void 0 : _a.productRemoved)
                        ? (_c = (_b = it.shortenedMedsDetails.alternateMedication) === null || _b === void 0 ? void 0 : _b.medication) === null || _c === void 0 ? void 0 : _c.name
                        : it.medication.name)) !== null && _d !== void 0 ? _d : ''
                });
            });
            break;
        case ControlledDialogActions.Edit:
            if (dialogConfig.action.payload.medication)
                controlledMedications = [
                    {
                        id: dialogConfig.action.payload.medication.code,
                        name: dialogConfig.action.payload.medication.name
                    }
                ];
            break;
    }
    return {
        showControlledMedicationDialog: showControlledMedicationDialog,
        onCancelControlDialog: onCancelControlDialog,
        requiresAuthentication: requiresAuthentication,
        handleLoginFlow: handleLoginFlow,
        controlledMedicationDialogOpen: !!dialogConfig,
        controlledMedications: controlledMedications,
        processingLogin: processingLogin
    };
};
export var ControlledMedicationDialog = function (props) {
    var handleClose = function () {
        props.handler.onCancelControlDialog();
    };
    var handleLogin = function () {
        props.handler.handleLoginFlow();
    };
    if (!props.handler.controlledMedicationDialogOpen)
        return null;
    return (React.createElement(StyledDialog, { open: true, size: 'xs', modal: true, testId: 'controlled-medication', title: 'Controlled medication', titleBarRight: React.createElement(Button, { iconOnly: true, onClick: handleClose, noShadowOnHover: true, subtleShadeOnHover: true, testId: 'controlled-medication-close', tooltip: 'Close' },
            React.createElement(CloseIcon, { size: '20', color: white50, noPadding: true })), actions: [
            React.createElement(StyledDialogButton, { variant: ButtonVariant.light, key: 'cancel', testId: 'controlled-medication-cancel', onClick: handleClose, disabled: props.handler.processingLogin }, "Cancel"),
            React.createElement(StyledDialogButton, { variant: ButtonVariant.primary, key: 'login', disabled: props.handler.processingLogin, testId: 'controlled-medication-login', onClick: handleLogin }, "Login")
        ], contentComponent: React.createElement("div", { className: styles.dialogContent },
            React.createElement("div", { className: styles.info }, "In order to comply with Australian prescribing standards, when you prescribe a controlled medication, you need to authenticate your prescriber details again."),
            React.createElement("div", { className: styles.notice },
                "Are you sure you want to prescribe the following",
                ' ',
                props.handler.controlledMedications.length > 1 ? 'medications' : 'medication',
                ":"),
            React.createElement("ul", { className: styles.medicationsAffected }, props.handler.controlledMedications.map(function (it, index) { return (React.createElement("li", { className: styles.item, key: it.id + "-" + index }, it.name)); }))) }));
};
